<template>
  <div class="col-md-12 m-0 p-0">
    <b-row>
      <b-col class="cards-container">
        <b-card class="card" 
        v-bind:class="{ active: currentFlag == 0 }"
        v-on:click="setFlag(0)"
        >
          <p class="m-0 p-0">New</p>
          <h4 class="m-0 p-0">{{showCount(0)}} entries</h4>
        </b-card>
      </b-col>
      <b-col class="cards-container">
        <b-card class="card" 
        v-bind:class="{ active: currentFlag == 1 }"
        v-on:click="setFlag(1)"
        >
          <p class="m-0 p-0">Postponed</p>
          <h4 class="m-0 p-0">{{showCount(1)}} entries</h4>
        </b-card>
      </b-col>
      <b-col class="cards-container">
        <b-card class="card" v-bind:class="{ active: currentFlag == 2 }"
        v-on:click="setFlag(2)"
        >
          <p class="m-0 p-0">Under Action</p>
          <h4 class="m-0 p-0">{{showCount(2)}} entries</h4>
        </b-card>
      </b-col>
      <b-col class="cards-container">
        <b-card class="card"
        v-bind:class="{ active: currentFlag == 3 }"
        v-on:click="setFlag(3)"
        >
          <p class="m-0 p-0">Completed</p>
          <h4 class="m-0 p-0">{{showCount(3)}} entries</h4>
        </b-card>
      </b-col>
    </b-row>
    <div class="col-md-12 m-0 p-0 my-3">
      <b-row>
        <b-col>
          <p class="labels m-0 p-0 pb-2">Search Item line booking ID etc</p>
          <b-form-input
            id="input-1"
            v-model="search"
            type="text"
            placeholder="Search Item"
            required
          ></b-form-input>
        </b-col>
        <b-col>
          <p class="labels m-0 p-0 pb-2">Choose a limit</p>
          <b-form-select @change="loadData" v-model="limit" :options="options"></b-form-select>
        </b-col>
        <b-col>
          <p class="labels m-0 p-0 pb-2">Choose between dates. 
            <span v-if="startDate || endDate" @click="resetDates" class="badge badge-danger">Reset</span>
          </p>
          <b-row>
            <b-col>
              <b-form-datepicker
                id="start"
                @change="loadData"
                v-model="startDate"
                class="mb-2"
              ></b-form-datepicker>
            </b-col>
            <b-col>
              <b-form-datepicker
                id="end"
                @change="loadData"
                v-model="endDate"
                class="mb-2"
              ></b-form-datepicker>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div class="col-md-12 m-0 p-0 my-3">
      <p class="labels">Total of {{totalPaymentFailedCount}} entries found</p>
    </div>

    <div
      class="col-md-12 m-0 p-2 my-2"
      v-if="currentSelected"
      style="border:1px solid #E9ECEF"
    >
      <b-row>
        <b-col md="9">
          <div>
            <b-button-toolbar key-nav aria-label="Toolbar with button groups">
              <b-button-group class="mx-1">
                <b-dropdown dropright text="Change Status">
                  <b-dropdown-item @click="openChangeStatusModel(0, 'new')">New</b-dropdown-item>
                  <b-dropdown-item @click="openChangeStatusModel(1, 'postpone')">Postpone</b-dropdown-item>
                  <!-- <b-dropdown-divider></b-dropdown-divider> -->
                  <b-dropdown-item @click="openChangeStatusModel(2, 'under action')">Under Action</b-dropdown-item>
                  <b-dropdown-item @click="openChangeStatusModel(3, 'completed')">Completed</b-dropdown-item>
                </b-dropdown>
              </b-button-group>
              <!-- <b-button-group class="mx-2">
                <b-button
                  variant="light border"
                  v-b-tooltip
                  title="Send Direct Message"
                >
                  <i
                    class="fa fa-envelope-o pt-1"
                    style="font-size:20px"
                    aria-hidden="true"
                  ></i>
                </b-button>
              </b-button-group> -->
            </b-button-toolbar>
          </div>
        </b-col>
        <b-col md="3" class="text-right">
          <b-button-group>
            <b-button variant="light border" disabled
              >Selected: {{ currentSelected.bookingId }}</b-button
            >
            <b-button @click="resertCurrentSelected">Reset</b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </div>
    <div class="col-md-12 m-0 p-0 my-3">
      <b-table
        :busy="loading"
        responsive
        :fields="fields"
        :items="filteredList"
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
      >
        <template #cell(#)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <p class="m-0 p-0">
              <b-icon icon="app"></b-icon>
            </p>
          </template>
        </template>
        <template #cell(bookingId)="data">
          <span v-b-tooltip.hover :title="data.item.comment">{{
            data.value
          }}</span>
        </template>
        <template #cell(fname)="data">
          <span
            class="link"
            @click="
              openProfile(
                data.item.customerData.id,
                data.item.customerData.mobile
              )
            "
            v-b-tooltip.hover
            title="Click to view profile"
          >
            {{ data.item.customerData.fName }}
          </span>
        </template>
        <template #cell(mobile)="data">
          <b-th v-b-tooltip.hover="checkVariant(data.item.customerData.activeStatus)[0].description" v-bind:style="{'background': checkVariant(data.item.customerData.activeStatus)[0].color}">
            <a
            class="m-0 p-0 px-2 py-1"
            style="text-decoration:none;color:white"
            :href="'tel:' + data.item.customerData.mobile"
            >{{ data.item.customerData.mobile }}
          </a>
          </b-th>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-5">
            <b-spinner class="align-middle"></b-spinner>
            <p class="my-3"><strong>We are Loading...</strong></p>
          </div>
        </template>
      </b-table>
      <div class="py-5" v-if="!loading && filteredList.length == 0">
          <div class="text-center text-danger my-5">
            <h3>There is no data around here.</h3>
          </div>
        </div>
    </div>
    <!-- <b-modal ref="statusChangeModal" scrollable :title="`${username}, changing status to ${action}?`" hide-footer>
      <div class="col-md-12 m-0 p-0">
        <div class="m-0 p-0">
          <p class="m-0 p-0">Previous Comments:</p>
        </div>
        <div
          class="col-md-12 m-0 p-3 previousComment"
          id="container"
          v-if="commentData.length > 0"
        >
          <div
            class="card col-md-10 p-2 mb-2"
            v-for="(data, index) in commentData"
            :key="index"
          >
            <p class="comment p-0 m-0">{{ data.comment }}</p>
            <div class="discription d-flex justify-content-between">
              <p class="p-0 m-0 labels">
                {{ data.createdAt | moment("from", "now") }}
              </p>
              <p class="p-0 m-0 labels">{{ data.userName }}</p>
            </div>
            <div class="text-right">
              <span style="font-size:10px" class="badge badge-success">{{
                checkFunnel(data.current_flag)
              }}</span>
            </div>
          </div>
        </div>
        <div class="text-center no-comments col-md-12" v-else>
          <img src="../../assets/no.svg" width="100px" class="my-3" />
          <p>No comments yet.</p>
        </div>
        <div class="remind p-3 row" v-if="status_to_change == 1">
          <div class="col-md-6">
            <label for="remind" class="label">I want a reminder?</label>
            <input v-model="remind" name="remind" type="checkbox" />
          </div>
          <div class="col-md-6">
            <label v-if="takeDate" for="calender"
              >When to remind you?
              <input
                class="form-control"
                type="date"
                v-if="takeDate"
                v-model="reminder_date"
              />
            </label>
          </div>
        </div>
        <div class="p-3">
          <textarea
            type="text"
            v-model="comment"
            placeholder="comment.."
            class="text-area form-control"
          ></textarea>
        </div>
        <div class="modal-footer">
          <button v-on:click="change_status()" class="ontrack-button">
            <span v-if="changing">Wait...</span>
            <span>I'm, Sure!</span>
          </button>
        </div>
      </div>
    </b-modal> -->
    <b-modal hide-footer v-model="changeStatusModal" ref="changeStatusModal" scrollable  id="send-sms" size="xl" title="Change status">
      <changeFlag :metaData="changeStatusMetaData" :id="changeStatusId"></changeFlag>
    </b-modal>
  </div>
</template>

<script>
const moment = require("moment");
const axios = require("axios");
import responsivenessData from "../../../Inventory/responsiveness"

export default {
  data() {
    return {
      changeStatusMetaData: '',
      changeStatusId: '',
      responsivenessData: responsivenessData,
      currentSelected: "",
      limit: 10,
      options: [
        { value: 10, text: "Just 10" },
        { value: 30, text: "30" },
        { value: 50, text: "50" },
        { value: 150, text: "A lot" },
      ],
      fields: [
        "#",
        {
          key: "bookingId",
          label: "ID",
        },
        {
          key: "extendId",
        },
        {
          key: "fName",
          label: "Name",
          sortable: true,
        },
        {
          key: "customerData.email",
          label: "Email",
        },
        {
          key: "mobile",
          label: "Mobile",
        },
        {
          key: "noOfDays",
          label: "Days",
          sortable: true,
        },
        {
          key: "amount",
        },
        {
          key: "noOfDays",
        },
        {
          key: "source",
        },
        {
          key: "createdAt",
          sortable: true,
          formatter: (value) => {
            return moment(value).format("LL");
          },
        },
      ],
      startDate: null,
      endDate: null,
      search: "",
      currentFlag: 0,
      loadingComments: '',
      flag: 0,
      commentData:'',
      action: '',
      status_to_change: 0,
      comment: '',
      changing: false,
      edit_id:'',
      customer_id:'',
      remind:'',
      takeDate:''

    };
  },
  watch: {
    startDate(){
      this.loadData()
    },
    endDate(){
      this.loadData()
    },
    currentFlag(){
      this.loadData()
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    checkVariant(data){
      var x = this.responsivenessData.filter(x=>{
        return x.activeStatus === data
      })
      if(x.length>0){
        return x
      }else{
        return [
          {
          activeStatus: data,
          color: 'red',
          description: 'Not Defined'
        }
        ]
      }
    },
    showCount(flag){
      var x = this.paymentFailedCount.filter(x=>{
        return x.flag === flag
      })
      if(x[0]){
        return x[0].count
      }else{
        return 0
      }
    },
    setFlag(flag){
      this.currentFlag = flag
    },
    openChangeStatusModel (status, status_name) {
      this.changeStatusId = this.currentSelected.customerData.id
      var obj = {
        flag: status,
        funnel: status_name,
        bookingId: this.currentSelected.id,
        funnelUrl: 'booking/payment',
        dispatch: 'get_extension_failure_data',
          dispatchPayload: {
          limit: this.limit,
          failed: true,
          flag: this.currentFlag,
          start: this.startDate ? moment(this.startDate).format('x') : null,
          end: this.endDate ? moment(this.endDate).format('x') : null
        }
      }
      this.changeStatusMetaData = obj
      this.$refs['changeStatusModal'].show()
    },
    change_status() {
      this.changing = true;
          axios
            .post(
              "https://glacier.on-track.in/api/booking/payment/" + this.edit_id,
              {
                comment: this.comment,
                flag: this.status_to_change,
                current_flag: this.status_to_change,
                current_status: this.status_computed,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem('agentToken')}`,
                },
              }
            )
            .then(() => {
              this.loadData()
              if (this.remind) {
                window.db
                  .collection("reminder")
                  .add({
                    reminder_date: this.reminder_date,
                    remind_status: 0,
                    read: 0,
                    message: this.comment,
                    date: new Date.now(),
                    id: this.edit_id,
                    table: "failedbooking",
                  })
                  .then(() => {
                    this.$refs['statusChangeModal'].hide()
                    this.comment = "";
                    this.$store.dispatch("get_expired_bookings");
                    this.changing = false;
                    this.selectedItem = "";
                  });
              } else {
                this.$refs['statusChangeModal'].hide()
                this.comment = "";
                this.$store.dispatch("get_expired_bookings");
                this.changing = false;
                this.selectedItem = "";
              }
            })
            .catch((err) => {
              this.message = err.msg;
              this.$toasted.global.my_app_error();
              this.changing = false;
              this.selectedItem = "";
            });
    },
    resetDates () {
      this.startDate = null
      this.endDate = null
    },
    resertCurrentSelected(){
      this.currentSelected = ""
    },
    openProfile(id, mobile) {
      this.$router.push({ path: "/userProfile/" + id + "/" + mobile });
    },
    onRowSelected(items) {
      if(items.length>0){
      this.currentSelected = items[0];
      } else{
      this.currentSelected = ""
      }
    },
    loadData() {
      this.$store.dispatch("get_extension_failure_data", {
        limit: this.limit,
        failed: true,
        flag: this.currentFlag,
        start: this.startDate ? moment(this.startDate).format('x') : null,
        end: this.endDate ? moment(this.endDate).format('x') : null
      });
      this.$store.dispatch("get_extension_failure_data_count")  
    },
  },
  computed: {
    changeStatusModal : {
        get () {
          return this.$store.state.changeStatusModal
        },
        set (newValue){
          this.$store.state.changeStatusModal = newValue
        }      
    },
    status_computed() {
      return this.flag;
    },
    someChanges() {
      return this.startDate && this.endDate && this.limit && this.currentFlag
    },
    paymentFailedData() {
      return this.$store.state.extension_payment_failure || [];
    },
    filteredList() {
     if(this.paymentFailedData.length > 0){
        return this.paymentFailedData.filter((post) => {
        return (
          post.customerData.fName.toLowerCase().includes(this.search.toLowerCase()) ||
          post.bookingId.toLowerCase().includes(this.search.toLowerCase()) ||
          post.customerData.mobile.toString().includes(this.search.toLowerCase())
        );
      });
     }else{
       return []
     }
    },
    username() {
      return localStorage.getItem("username");
    },
    agent_id() {
      return localStorage.getItem("agent_id");
    },
    loading() {
      return this.$store.state.loading_api;
    },
    paymentFailedCount () {
      return this.$store.state.paymentFailedCount || [];
    },
    totalPaymentFailedCount(){
      var count = 0
      if(this.paymentFailedCount.length>0){
        this.paymentFailedCount.filter(x=>{
          count+=x.count
        })
      }else{
        count = 0
      }
      return count
    }
  },
};
</script>

<style scoped>
.labels {
  color: gray;
  font-size: 13px;
}
.cards-container {
  cursor: pointer;
}
.card:hover {
  background: #7977c2;
  color: white;
}
.active {
  border-top: 3px solid #7977c2;
  background: #f7f7f8;
}
</style>
